import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';
import SpotifyExchangeRateBox from "./SpotifyExchangeRate";
import ViewUploadFileLogBox from "./ViewUploadFileLog";


export default function Spotify(subEntity: any) {

    const [showtab, setShowTab] = useState(false);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("Spotify");
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    let [getReportSuccess, setGetReportSuccess] = useState(false);
    let [dataLoadedSuccess, setDataLoadedSuccess] = useState(false);
    let [dataLoadedFail, setDataLoadedFail] = useState(false);
    let [geneInvHours, setGeneInvHours] = useState(false);
    let [deleteUnpData, setDeleteUnpData] = useState(false);
    let [deletePData, setDeletePData] = useState(false);
    let [checkInvNoDate, setCheckInvNoDate] = useState(false);
    let [checkReportData, setCheckReportData] = useState(false);
    let [dataDeleted, setDataDeleted] = useState(false);

    let [spotifyExchangeRateStatus, setSpotifyExchangeRateStatus] = useState(false);
    const newTransaction = () => {
        spotifyExchangeRateStatus = true;
        setSpotifyExchangeRateStatus(spotifyExchangeRateStatus)
    }

    let [fileUploadHistoryStatus, setFileUploadHistoryStatus] = useState(false);
    const viewUploadHistory = () => {
        setFileUploadHistoryStatus(true)
    }

    const ViewUploadFileLogClose = () => {
        fileUploadHistoryStatus = false
        setFileUploadHistoryStatus(false)
    }

    let [collapsedGetReport, setcollapsedGetReport] = useState(false);
    let [collapsedCheckReport, setcollapsedCheckReport] = useState(false);
    let [collapsedPlugReport, setcollapsedPlugReport] = useState(false);


    return (
        <div className="ws-12 pm">

            <div className="ws-12">

                <div className="box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width"><i className="icon-file-add"></i> Get Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetReport(!collapsedGetReport)}>
                                <i className={collapsedGetReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            {collapsedGetReport && <>
                            <button title="Refresh File Details" className="icon-btn edit btn-xxs pull-right" data-ng-click="init()">
                                <i className="icon-refresh"></i>
                            </button>
                            <button title="Check Temporary Table" className="btn-warning fill btn-xxs pull-right" ng-click="openTempCheckTable('spotify')"><i className="icon-doc-file"></i> </button>
                            <button title="File Upload History" className="btn-xxs pull-right icon-btn info" ng-className="(statusFile == 0) ? 'icon-btn info' : 'btn-warning'" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                            </>}
                        </h2>
                    </div>
                    {collapsedGetReport && <>
                    <div className="box-content" data-ng-hide="getReportDsply">

                        {
                            getReportSuccess && <div className="alert alert-info">Generation of Report(s) in process</div>
                        }
                        {
                            dataLoadedSuccess && <div className="alert alert-info">Data has been uploaded succesffuly</div>
                        }
                        {
                            dataLoadedFail && <div className="alert alert-info">An error has occur, please check file status for more details</div>
                        }

                        <div className="ws-12">
                            <div className="ws-4">
                                <div className="form-format">
                                    <label className="control-label">Report</label>
                                    <div className="label-entries">
                                        <select data-ng-model="selectReportUpload"  >
                                            <option value="" data-ng-selected="true" selected>Choose a report</option>
                                            <option value="brkSumm" >Breakage Summary</option>
                                            <option value="brk" >Breakage</option>
                                            <option value="strmSumm" >Streaming Summary</option>
                                            <option value="strm" >Streaming</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="ws-3 mtl">
                                <label className="control-label " >  Upload File</label>
                                <div className="label-entries">
                                    <label className="btn icon-btn edit btn-file btn-sm">
                                        <i className="icon-upload"></i>
                                        <input type="file" />
                                    </label>
                                </div>
                            </div>

                            <div className="ws-5 ptl">
                                <div className="form-format">
                                    <div className="progress">
                                        <div className="progress-bar ">
                                            %
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-footer" data-ng-hide="getReportDsply">
                        <a className="btn icon-btn delete pull-left  " data-ng-show="brkChck != 0 || strmChck != 0 || brkSummChck != 0 || strmSummChck != 0" data-ng-click="truncateSpotifyReports()">
                            <i className="icon-close"></i> Clear Table
                        </a>

                        <a className="icon-btn warning " onClick={() => newTransaction()}>
                            <i className="icon-plus1"></i> Set Exchange Rate
                        </a>

                        <a className="icon-btn info  " data-ng-hide="showLoad" data-ng-click="loadFile()">
                            <i className="icon-upload"></i> Load
                        </a>
                        <a className="btn icon-btn edit  " data-ng-show="brkChck != 0 ; strmChck != 0 ; brkSummChck != 0 ; strmSummChck != 0" data-ng-click="processPlug()">
                            <i className="icon-calculator"></i> Transfer to Plug Table
                        </a>
                    </div>
                    </>}
                </div>

                <div className="box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12"><i className="icon-file-add"></i> Check Report
                            <span data-ng-show="reportDetails.length &gt; 0" > - 0 record(s) found</span>
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedCheckReport(!collapsedCheckReport)}>
                                <i className={collapsedCheckReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                        </h2>
                    </div>
                    {collapsedCheckReport && <>
                    <div className="box-content " data-ng-hide="getChkReportDsply">
                        <div className="mbl row-fluid">

                            <form name="frmCheckReport" >
                                <div className="ws-4">
                                    <div className="form-format">
                                        <label className="control-label">Report</label>
                                        <div className="label-entries">
                                            <select data-ng-model="selectReport" data-ng-click="resetReport();"  >
                                                <option value="" data-ng-selected="true" selected>Choose a report</option>
                                                <option value="brkSumm" >Breakage Summary</option><option value="brk" >Breakage</option><option value="strmSumm" >Streaming Summary</option><option value="strm" >Streaming</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="label-entries span2-4 ptl">
                                    <a className="btn icon-btn edit mb mll" data-ng-click="getSpotifyReports();">
                                        <span data-ng-hide="balanceDetails.length &gt; 0"><i className="icon-search1"></i> Check</span>
                                        <span data-ng-show="balanceDetails.length &gt; 0" ><i className="icon-reload"></i> Refresh</span>
                                    </a>
                                </div>
                            </form>
                        </div>
                        <div className="row-fluid">
                            <div className="table-responsive_big">

                                {
                                    checkInvNoDate && <div className="alert alert-info">Please select a report</div>
                                }
                                {
                                    checkInvNoDate && <div className="alert alert-info">No data found for this month</div>
                                }
                                {
                                    checkInvNoDate && <div className="alert alert-info">Data has successfully been deleted</div>
                                }
                                <table className="table " data-ng-show="reportDetails.length &gt; 0">
                                    <thead>

                                    </thead>
                                    <tbody>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="clearfix">

                        </div>
                        <div className="box-footer " data-ng-show="reportDetails.length &gt; 0 ; !getChkReportDsply">


                            <a className="icon-btn info" data-ng-click="openGetSummary()">
                                <i className="icon-file-add"></i> View Summary
                            </a>

                            <a className="btn icon-btn delete " data-ng-click="deleteSpotifyReports()">
                                <i className="icon-close"></i> Remove Data
                            </a>
                        </div>
                    </div>
</>}
                </div>

                <div className="box mb">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width"><i className="icon-file-add"></i> Plug Report
                            <span data-ng-show="plugTotalItems &gt; 0" > -  record(s) found</span>
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedPlugReport(!collapsedPlugReport)}>
                                <i className={collapsedPlugReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            {collapsedPlugReport && <>
                            <button title="Refresh File Details" data-ng-hide="getChkPlugReportDsply" className="icon-btn edit btn-xxs pull-right " data-ng-click="getPlugHeader()">
                                <i className="icon-refresh"></i>
                            </button>
                            </>}
                        </h2>
                    </div>
                    {collapsedPlugReport && <>
                    {
                        geneInvHours && <div className="alert alert-info">Invoice(s) creation have started and may take few minutes to complete</div>
                    }
                    {
                        deleteUnpData && <div className="alert alert-info">Removing unprocess data has started and may take few minutes to complete</div>
                    }
                    {
                        deletePData && <div className="alert alert-info">Removing process data &amp; invoices has started and may take few minutes to complete</div>
                    }

                    <div className="box-content " data-ng-hide="getChkPlugReportDsply">
                        <div className="form-horizontal row-fluid">
                            <div className="form-format ws-6">
                                <label className="control-label " >Filter Plug Header</label>

                                <div className="label-entries">
                                    <input id="filterPlugTbl" type="text" className="input-sm " data-ng-model="filterPlugTbl" placeholder="Search" />
                                </div>
                            </div>
                        </div>
                        <div className="row-fluid">
                            <div className="table-responsive_big">
                                <table className="table " data-ng-show="plugTotalItems &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Royalty Period</th>
                                            <th>Currency</th>
                                            <th>Header Type</th>
                                            <th>Description</th>
                                            <th>Exch Rate</th>
                                            <th>Inverse Rate</th>
                                            <th>Currency Amount</th>
                                            <th>Quantity</th>
                                            <th>Home Value</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="box-footer">

                            <ul className="pull-left m0 pagination ng-isolate-scope ng-valid " data-items-per-page="plugListItemsPerPage" total-items="plugTotalItems" ng-model="plugCurrentPage" max-size="3" ng-change="plugPageChanged(plugCurrentPage, plugListItemsPerPage)" data-ng-show="plugTotalItems &gt; 10">
                                <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
                                <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
                                <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>

                            </ul>


                            <div className="page-size-control pull-left">
                                <select title="Items per page" data-ng-options="item as item for item in pageSizes" data-ng-change="plugCurrentPage=1; plugPageChanged(plugCurrentPage, plugListItemsPerPage)" data-ng-model="plugListItemsPerPage" data-ng-show="plugTotalItems &gt; 10" ><option value="0" selected label="10">10</option><option value="1" label="20">20</option><option value="2" label="50">50</option><option value="3" label="100">100</option></select>
                            </div>


                            <div className="pull-right ws-6 " data-ng-show="plugTotalItems &gt; 0 ; !getChkPlugReportDsply">
                                <div className="hover-box pull-right mts">
                                    <button className="icon-btn edit "><i className="icon-plus1-circle"></i> Generate Invoice</button>
                                    <div className="hover-block" >

                                    </div>
                                </div>

                                <input id="distributionFee" type="number" className="input-sm ws-7 pull-right " data-ng-model="distributionFee" placeholder="Distribution Fee in %" />
                            </div>
                        </div>
                    </div>
                    </>}
                </div>
            </div>
            {
                (() => {
                    if (spotifyExchangeRateStatus) {
                        return <SpotifyExchangeRateBox param={spotifyExchangeRateStatus} />
                    }
                })()
            }
            {
                (() => {
                    if (fileUploadHistoryStatus) {
                        return <ViewUploadFileLogBox param={fileUploadHistoryStatus} ViewUploadFileLogClose={ViewUploadFileLogClose}/>
                    }
                })()
            }
        </div>
    );
}
